import { apiServer } from 'settings/web-services/api';

export const getAgentTeamIntelTags = () => {
  return apiServer.get('/agentActivity/tags');
};

export const postAgentIntel = (cfg) => {
  return apiServer.post('/agentActivity', cfg);
};

export const getAgentIntelFeed = (cfg) => {
  return apiServer.post('/agentActivity/search', cfg);
};

export const getAgentTeamIntelTagsForClient = (agentId: number) => {
  return apiServer.get(`/agentActivity/tags?agentId=${agentId}`);
};
